import MarkDownRenderer from '../../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
## **Query Parameters**

Query parameters allow you to append key-value pairs to your request URL for
filtering, pagination, sorting, and other controls.

### **Example**

\`\`\`
?page=2&limit=20
\`\`\`

### **Usage in HawkClient**

Add query parameters using the **Params** tab while composing a request.
Each parameter is defined as a key-value pair and automatically appended
to the request URL.

![Query Parameters in HawkClient](/send-requests/Params.png)
`;

const QueryParamsTab = () => {
    return (
        <MarkDownRenderer
            title="Query Parameters"
            markDownText={markdownContent}
        />
    );
};

export default QueryParamsTab;
